import { Link, Tag } from '@overdose/components'
import { Button } from '~/components'
import { Image } from '~/components/Image'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { getImageSrc } from '~/helpers'
import { useProject, useSession } from '~/hooks'
import { Project } from '~/sections/ProjectDetails/ProjectDetails.types'

import BookmarkButton from '../BookmarkButton/BookmarkButton'
import DifficultyRating from '../DifficultyRating/DifficultyRating'

export default function MakerHubProjectCard({
  thumbnail,
  category,
  difficulty,
  title,
  excert,
  projectId,
  slug,
  isBookmarked: initialIsBookmarked,
}: Project) {
  const { session } = useSession()
  const { isBookmarked, handleOnBookMarkProject } = useProject({
    projectTitle: title,
    projectId,
    isBookmarked: initialIsBookmarked,
  })

  return (
    <div>
      <div className='relative'>
        <Link
          to={slug}
          title={`${title} details`}
          ariaLabel={`${title} details`}>
          <Image
            src={
              getImageSrc(thumbnail?.src, '428') ||
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mOcu3xuPQAGLAJi0T/fOgAAAABJRU5ErkJggg=='
            }
            addSrcSet={false}
            width={428}
            height={thumbnail.height}
            alt={thumbnail.altText}
            className='object-cover rounded-md max-h-[350px] aspect-[4/3] w-full'
          />
        </Link>
        {session?.token?.isLoggedIn && (
          <div className='absolute right-6 top-6'>
            <BookmarkButton
              active={isBookmarked}
              size='lg'
              onClickToggle={handleOnBookMarkProject}
            />
          </div>
        )}
      </div>

      <div className='p-4 bg-white'>
        <div
          className='flex gap-2 flex-wrap py-1'
          style={
            {
              '--tag-default-color-bg':
                'var(--color-text-primary-blue, #0C254C)',
              '--tag-default-color-text': 'white',
            } as React.CSSProperties
          }>
          <Tag size='sm' variant='default'>
            <Typography
              className='uppercase'
              tag={TypographyTag.span}
              variant={TypographyVariant.BodySmall}>
              {category.name}
            </Typography>
          </Tag>
        </div>
        <div className='flex gap-y-4 flex-col'>
          <Typography
            className='flex gap-2 items-center'
            tag={TypographyTag.div}
            variant={TypographyVariant.BodyLargeBold}>
            {title}
          </Typography>
          <div className='flex gap-4 flex-wrap'>
            <Typography
              className='flex gap-2 items-center'
              tag={TypographyTag.div}
              variant={TypographyVariant.BodyRegularBold}>
              Difficulty <DifficultyRating difficulty={difficulty} />
            </Typography>
          </div>
          <Typography
            tag={TypographyTag.p}
            className='line-clamp-1'
            variant={TypographyVariant.BodyRegular}>
            {excert}
          </Typography>
        </div>

        <div className='grid  gap-x-2 mt-6 2xl:mt-12 gap-y-2 grid-cols-2 lg:grid-cols-1 2xl:grid-cols-2'>
          <Button status='primary' href={slug}>
            <Typography
              className='flex gap-2 items-center'
              tag={TypographyTag.span}
              variant={TypographyVariant.BodyRegularBold}>
              Open Project
            </Typography>
          </Button>

          <Button status='secondary' href={`${slug}#materials`}>
            <Typography
              className='flex gap-2 items-center'
              tag={TypographyTag.span}
              variant={TypographyVariant.BodyRegularBold}>
              View Materials
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  )
}
